import {Injectable} from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {TerceroUPPasarelaContacto} from '../_models/tercero-up-pasarela-contacto';

@Injectable({
  providedIn: 'root'
})
export class TerceroUpPasarelaContactoService {
  private rutServicio = AppSettings.rutServiciosTER + '/api/tercerosUPPasarelasContactos';

  constructor(private httClient: HttpClient) {
  }

  listContactosByPasarela(idTerceroUPPasarela: string) {
    return this.httClient.get(`${this.rutServicio}/listContactosByPasarela/${idTerceroUPPasarela}`).pipe(map(res => res as TerceroUPPasarelaContacto[]));
  }

  crearContactoVersion(registro: Partial<TerceroUPPasarelaContacto>) {
    return this.httClient.post(`${this.rutServicio}/createPasareleVersion`, registro).pipe(map(res => res as TerceroUPPasarelaContacto));
  }

  inhabilitarContacto(registro: Partial<TerceroUPPasarelaContacto>) {
    return this.httClient.post(this.rutServicio, registro);
  }
}
